import React, { Children, ReactElement } from 'react';
import { Container } from '@fiverr-private/layout_components';
import type { Types } from '@fiverr-private/theme';
import { renderChildren } from '@fiverr-private/ui_utils';
import { usePopoverContext } from '@fiverr-private/popover';
import { ButtonProps } from '@fiverr-private/button';
import { getItemToFocus } from '../../DropdownMenu/useMenuNavigation/utils';
import useDropdownContext from '../../Dropdown/useDropdownContext';

const DropdownHeaderActions = ({
  children,
  height = '24px',
  display = 'flex',
  ...rest
}: Types.ContainerProps & { children: ReactElement<ButtonProps> | ReactElement<ButtonProps>[] }) => {
  const { headerActionsRef, setFocusedItem, items, anchorRef } = useDropdownContext();
  const { setOpen } = usePopoverContext();
  const handleKeyDown = (e, child, isFirstAction, isLastAction) => {
    if (e.code === 'Tab') {
      if (e.shiftKey && isFirstAction) {
        setOpen(false);
        anchorRef?.current?.focus();
        e.preventDefault();
      }
      if (!e.shiftKey && isLastAction) {
        setFocusedItem(getItemToFocus({ startIndex: 0, items }));
        anchorRef?.current?.focus();
        e.preventDefault();
      }
    }

    child?.props?.onKeyDown?.(e);
  };
  return (
    <Container ref={headerActionsRef} display={display} height={height} {...rest}>
      {Children.map(children, (child: ReactElement<ButtonProps>, index) => {
        const isFirstAction = index === 0;
        const isLastAction = index === Children.count(children) - 1;

        return renderChildren(child, {
          onKeyDown:
            isFirstAction || isLastAction ? (e) => handleKeyDown(e, child, isFirstAction, isLastAction) : undefined,
        });
      })}
    </Container>
  );
};

DropdownHeaderActions.displayName = 'DropdownHeaderActions';
export default DropdownHeaderActions;
